import React, { useCallback } from 'react';

import { SideNavigation } from '@af/design-system-docs-ui';
import { useToggleSideNav } from '@atlassian/navigation-system';

import { navigation } from '../router/navigation';

type SideNavWrapperProps = {
	currentPath: string;
};

/**
 * __SideNavWrapper__
 *
 * A wrapper component that provides the side navigation with responsive behavior.
 * It automatically closes the navigation menu on mobile devices when a menu item is clicked,
 * while keeping it open on desktop views.
 */
export const SideNavWrapper = ({ currentPath }: SideNavWrapperProps) => {
	const toggleSideNav = useToggleSideNav();

	const handleItemClick = useCallback(() => {
		const { matches } = window.matchMedia('(min-width: 64rem)');
		if (!matches) {
			toggleSideNav();
		}
	}, [toggleSideNav]);

	return (
		<SideNavigation
			id="side-navigation"
			navigation={navigation}
			currentPath={currentPath}
			onItemClick={handleItemClick}
		/>
	);
};
